import React, { useRef } from 'react';
import styled from 'styled-components';
import { Text } from "../Text";
import { theme } from "../../theme";
import { IconButton } from "../Button";
import { ToastButton } from "./ToastButton";
import { Separator } from "../Separator";
import { IconCheckCircleFill } from "@frameio/vapor-icons/build/esm/icons/IconCheckCircleFill";
import { IconX } from "@frameio/vapor-icons/build/esm/icons/IconX";
import { IconInfoFill } from "@frameio/vapor-icons/build/esm/icons/IconInfoFill";
import { IconWarningFill } from "@frameio/vapor-icons/build/esm/icons/IconWarningFill";
import { IconXCircleFill } from "@frameio/vapor-icons/build/esm/icons/IconXCircleFill";
import { Box } from "../Box";
import { useToggleFocus } from "../../hooks/useToggleFocus/useToggleFocus";
import Alert from '@reach/alert';
export function ToastAlert(_ref) {
  var title = _ref.title,
      details = _ref.details,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'neutral' : _ref$variant,
      onRequestRetry = _ref.onRequestRetry,
      onRequestClose = _ref.onRequestClose,
      adornmentBefore = _ref.adornmentBefore,
      adornmentAfter = _ref.adornmentAfter,
      initialFocusRefProp = _ref.initialFocusRef,
      _ref$tryAgainText = _ref.tryAgainText,
      tryAgainText = _ref$tryAgainText === void 0 ? 'Try Again' : _ref$tryAgainText,
      _ref$closeLabel = _ref.closeLabel,
      closeLabel = _ref$closeLabel === void 0 ? 'close' : _ref$closeLabel;
  var initialFocusRef = useRef(null);
  useToggleFocus(initialFocusRefProp || initialFocusRef, true);

  function renderAdornmentAfter() {
    var renderCustomAdornment = typeof adornmentAfter === 'function' ? adornmentAfter(onRequestClose) : adornmentAfter;
    return /*#__PURE__*/React.createElement(React.Fragment, null, (onRequestRetry || adornmentAfter) && /*#__PURE__*/React.createElement(React.Fragment, null, onRequestRetry ? /*#__PURE__*/React.createElement(ToastButton, {
      onClick: onRequestRetry
    }, tryAgainText) : renderCustomAdornment, /*#__PURE__*/React.createElement(Box, {
      width: 4
    }), onRequestClose && /*#__PURE__*/React.createElement(Separator, {
      stretch: true,
      gap: 8,
      vertical: true
    })), onRequestClose && /*#__PURE__*/React.createElement(IconButton, {
      label: closeLabel,
      size: "small",
      ref: initialFocusRef,
      onClick: onRequestClose,
      variant: "link",
      icon: /*#__PURE__*/React.createElement(IconX, {
        size: 16
      })
    }));
  }

  return /*#__PURE__*/React.createElement(StyledToast, null, (variant !== 'neutral' || adornmentBefore) && /*#__PURE__*/React.createElement(AdornmentBeforeContainer, null, adornmentBefore || /*#__PURE__*/React.createElement(IconForVariant, {
    variant: variant
  })), /*#__PURE__*/React.createElement(TextContainer, {
    $hasAdornment: adornmentAfter || onRequestRetry,
    $hasCloseButton: !!onRequestClose
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "body",
    color: "primary"
  }, title), details && /*#__PURE__*/React.createElement(Text, {
    variant: "secondary",
    color: "secondary"
  }, details)), renderAdornmentAfter());
}
var AdornmentBeforeContainer = styled.div.withConfig({
  displayName: "ToastAlert__AdornmentBeforeContainer",
  componentId: "vapor__rsc89h-0"
})(["margin-right:", ";"], theme.spaces[8]);

function getTextMarginRight(_ref2) {
  var $hasAdornment = _ref2.$hasAdornment,
      $hasCloseButton = _ref2.$hasCloseButton;

  if (!$hasCloseButton && !$hasAdornment) {
    return theme.spaces[0];
  }

  if ($hasAdornment) {
    return theme.spaces[24];
  }

  return theme.spaces[12];
}

var TextContainer = styled(Alert).withConfig({
  displayName: "ToastAlert__TextContainer",
  componentId: "vapor__rsc89h-1"
})(["padding:", " 0;min-height:100%;display:flex;align-items:baseline;& >:first-child{margin-right:", ";}margin-right:", ";"], theme.spaces[8], theme.spaces[8], getTextMarginRight);
var StyledToast = styled.div.withConfig({
  displayName: "ToastAlert__StyledToast",
  componentId: "vapor__rsc89h-2"
})(["background:", ";border-radius:", ";align-items:center;min-height:40px;font-style:normal;padding:0 ", " 0 ", ";text-align:left;display:inline-flex;position:relative;box-shadow:0 4px 4px rgba(0,0,0,0.25);border:1px solid ", ";"], theme.colors.palette.grey30, theme.radii[8], theme.spaces[8], theme.spaces[12], theme.colors.border.primary);
var shadow = {
  float: 'left'
};

function IconForVariant(_ref3) {
  var variant = _ref3.variant;

  switch (variant) {
    case 'success':
      return /*#__PURE__*/React.createElement(IconCheckCircleFill, {
        style: shadow,
        color: theme.colors.icon.success
      });

    case 'info':
      return /*#__PURE__*/React.createElement(IconInfoFill, {
        style: shadow,
        color: theme.colors.palette.brandPrimary
      });

    case 'warning':
      return /*#__PURE__*/React.createElement(IconWarningFill, {
        style: shadow,
        color: theme.colors.palette.alertWarning
      });

    case 'error':
      return /*#__PURE__*/React.createElement(IconXCircleFill, {
        style: shadow,
        color: theme.colors.palette.alertError
      });

    default:
      return null;
  }
}